import { redirect, type RouteObject } from "react-router";
import { lazy } from 'react';
import PrivacyPolicyPage from './pages/privacy';
import TermsOfUsePage from './pages/terms';
import HomePage from './pages/index';
// Keep the homepage in the initial client bundle; all other route modules are
// split out. React Router resolves route modules during SSR, so page metadata
// and content remain present in server-rendered HTML.
const BlogPage = lazy(() => import('./pages/blog'));
const BlogPostPage = lazy(() => import('./pages/blog/[slug]'));
const SpanishBlogPage = lazy(() => import('./pages/es/blog'));
const SpanishBlogPostPage = lazy(() => import('./pages/blog/[slug]'));
const DestinationsPage = lazy(() => import('./pages/destinations'));
const ServicesPage = lazy(() => import('./pages/services'));
const QuotePage = lazy(() => import('./pages/quote'));
const AboutPage = lazy(() => import('./pages/about'));
const ContactPage = lazy(() => import('./pages/contact'));
const SpanishHomePage = lazy(() => import('./pages/es/index'));
const SpanishDestinationsPage = lazy(() => import('./pages/es/destinos'));
const SpanishServicesPage = lazy(() => import('./pages/es/servicios'));
const SpanishAboutPage = lazy(() => import('./pages/es/nosotros'));
const SpanishContactPage = lazy(() => import('./pages/es/contacto'));
const SpanishQuotePage = lazy(() => import('./pages/es/cotizacion'));
const MessagingPolicyPage = lazy(() => import('./pages/messaging-policy'));
const SpanishMessagingPolicyPage = lazy(() => import('./pages/es/politica-mensajes'));
const FAQPage = lazy(() => import('./pages/faq'));
const SpanishFAQPage = lazy(() => import('./pages/es/preguntas-frecuentes'));
const CaribbeanPage = lazy(() => import('./pages/destinations/caribbean'));
const MaldivesPage = lazy(() => import('./pages/destinations/maldives'));
const BaliPage = lazy(() => import('./pages/destinations/bali'));
const SantoriniPage = lazy(() => import('./pages/destinations/santorini'));
const CostaRicaPage = lazy(() => import('./pages/destinations/costa-rica'));
const AlaskaCruisePage = lazy(() => import('./pages/destinations/alaska-cruise'));
const AmalfiCoastPage = lazy(() => import('./pages/destinations/amalfi-coast'));
const MediterraneanCruisePage = lazy(() => import('./pages/destinations/mediterranean-cruise'));
const EsCaribbeanPage = lazy(() => import('./pages/es/destinos/caribe'));
const EsMaldivesPage = lazy(() => import('./pages/es/destinos/maldivas'));
const EsBaliPage = lazy(() => import('./pages/es/destinos/bali'));
const EsSantoriniPage = lazy(() => import('./pages/es/destinos/santorini'));
const EsCostaRicaPage = lazy(() => import('./pages/es/destinos/costa-rica'));
const EsAlaskaCruisePage = lazy(() => import('./pages/es/destinos/crucero-alaska'));
const ProdNotFoundPage = lazy(() => import('./pages/_404'));
const LandingPage = lazy(() => import('./pages/lp'));
const ReferralPage = lazy(() => import('./pages/referral'));
const TestimonialsPage = lazy(() => import('./pages/testimonials'));
const NurturePage = lazy(() => import('./pages/admin/nurture'));
const AdPerformancePage = lazy(() => import('./pages/admin/ad-performance'));
const NotFoundPage = import.meta.env.DEV ? lazy(() => import('../dev-tools/src/PageNotFound')) : ProdNotFoundPage;
export const routes: RouteObject[] = [{
  path: '/',
  element: <HomePage />
}, {
  path: '/destinations',
  element: <DestinationsPage />
}, {
  path: '/services',
  element: <ServicesPage />
}, {
  path: '/quote',
  element: <QuotePage />
}, {
  path: '/about',
  element: <AboutPage />
}, {
  path: '/contact',
  element: <ContactPage />
},
// Spanish routes
{
  path: '/es',
  element: <SpanishHomePage />
}, {
  path: '/es/destinos',
  element: <SpanishDestinationsPage />
}, {
  path: '/es/servicios',
  element: <SpanishServicesPage />
}, {
  path: '/es/nosotros',
  element: <SpanishAboutPage />
}, {
  path: '/es/contacto',
  element: <SpanishContactPage />
}, {
  path: '/es/cotizacion',
  element: <SpanishQuotePage />
}, {
  path: '/messaging-policy',
  element: <MessagingPolicyPage />
}, {
  path: '/es/politica-mensajes',
  element: <SpanishMessagingPolicyPage />
}, {
  path: '/faq',
  element: <FAQPage />
}, {
  path: '/es/preguntas-frecuentes',
  element: <SpanishFAQPage />
}, {
  path: '/blog',
  element: <BlogPage />
}, {
  path: '/blog/:slug',
  element: <BlogPostPage />
}, {
  path: '/es/blog',
  element: <SpanishBlogPage />
}, {
  path: '/es/blog/:slug',
  element: <SpanishBlogPostPage language="es" />
},
// Destination landing pages (EN)
{
  path: '/destinations/caribbean',
  element: <CaribbeanPage />
}, {
  path: '/destinations/maldives',
  element: <MaldivesPage />
}, {
  path: '/destinations/bali',
  element: <BaliPage />
}, {
  path: '/destinations/santorini',
  element: <SantoriniPage />
}, {
  path: '/destinations/costa-rica',
  element: <CostaRicaPage />
}, {
  path: '/destinations/alaska-cruise',
  element: <AlaskaCruisePage />
}, {
  // Preserve inbound links that use the common “cruice” misspelling with a
  // server-rendered permanent redirect, so crawlers only index the canonical URL.
  path: '/destinations/alaska-cruice',
  loader: () => redirect('/destinations/alaska-cruise', 301),
}, {
  path: '/destinations/amalfi-coast',
  element: <AmalfiCoastPage />
}, {
  path: '/destinations/mediterranean-cruise',
  element: <MediterraneanCruisePage />
},
// Destination landing pages (ES)
{
  path: '/es/destinos/caribe',
  element: <EsCaribbeanPage />
}, {
  path: '/es/destinos/maldivas',
  element: <EsMaldivesPage />
}, {
  path: '/es/destinos/bali',
  element: <EsBaliPage />
}, {
  path: '/es/destinos/santorini',
  element: <EsSantoriniPage />
}, {
  path: '/es/destinos/costa-rica',
  element: <EsCostaRicaPage />
}, {
  path: '/es/destinos/crucero-alaska',
  element: <EsAlaskaCruisePage />
}, {
  path: '/referral',
  element: <ReferralPage />
}, {
  path: '/testimonials',
  element: <TestimonialsPage />
}, {
  path: '/lp/:slug',
  element: <LandingPage />
}, {
  path: '/admin/nurture',
  element: <NurturePage />
}, {
  path: '/admin/ad-performance',
  element: <AdPerformancePage />
}, {
   path: '/privacy',
   element: <PrivacyPolicyPage />,
 }, {
   path: '/terms',
   element: <TermsOfUsePage />,
 }, {
  path: '*',
  element: <NotFoundPage />
}];

// Types for type-safe navigation
export type Path = '/' | '/destinations' | '/services' | '/quote' | '/about' | '/contact' | '/es' | '/es/destinos' | '/es/servicios' | '/es/nosotros' | '/es/contacto' | '/es/cotizacion' | '/messaging-policy' | '/es/politica-mensajes' | '/blog' | `/blog/${string}`;
export type Params = Record<string, string | undefined>;
